import { ImportInvestorEntitiesUpdateMethodOptionEnum } from './types';

export const investorEntitiesSteps = [
  { name: 'Getting Started', status: 'IN_PROGRESS' },
  { name: 'Upload Data File', status: 'NOT_STARTED' },
  { name: 'Investor Entities', status: 'NOT_STARTED' },
  { name: 'Households', status: 'NOT_STARTED' },
  { name: 'Groups', status: 'NOT_STARTED' }
];

export const investorEntitiesDescriptionSectionData = {
  title: 'Import Investor Entities performs the following actions',
  description: [
    'Validates investor house-holding.',
    'Updates existing entities or creates new entities based on the supplied identifier in the import file.',
    'Provides a preview of all changes before saving.'
  ]
};
export const investorEntitiesColumnsSectionData = {
  title: 'Provide the following columns in the upload file',
  columns: [
    { name: 'Entity Name', isRequired: false },
    { name: 'Household Name', isRequired: false },
    { name: 'Group Name', isRequired: false },
    { name: 'Primary Entity', isRequired: false },
    { name: 'Total Entity Value', isRequired: false },
    { name: 'OC Ratio', isRequired: false },
    { name: 'Default Bite Size 1', isRequired: false },
    { name: 'Default Bite Size 2', isRequired: false },
    { name: 'Client Advisor Owner', isRequired: false },
    { name: 'Tax Status', isRequired: false },
    { name: 'On Hold', isRequired: false },
    { name: 'Entity Inception Date', isRequired: false },
    { name: 'Sectors to Avoid', isRequired: false },
    { name: 'SRI', isRequired: false },
    { name: 'Custodied', isRequired: false },
    { name: 'Unmanaged', isRequired: false },
    { name: 'Always Show', isRequired: false },
    { name: 'About Investor Note', isRequired: false },
    { name: 'Qualified Purchaser', isRequired: false },
    { name: 'Qualified Client', isRequired: false },
    { name: 'Accredited Investor', isRequired: false },
    { name: 'Entity Category', isRequired: false },
    { name: 'Entity Type', isRequired: false },
    { name: 'Entity Type Description', isRequired: false },
    { name: 'Advisor Reporting Account Number', isRequired: false }
  ]
};

export const importInvestorEntitiesUpdateMethodBannerDescriptions = {
  [ImportInvestorEntitiesUpdateMethodOptionEnum.UpdateUsingEntityCRMID]:
    'The Entity CRM ID can be set to a custom identifier, for example, one managed by an external CRM.  This method allows you to create new Investor Entities or update any existing Investor Entity that already has its Entity CRM ID set.  Records that do not have an Entity CRM ID set cannot be updated using this method.',
  [ImportInvestorEntitiesUpdateMethodOptionEnum.UpdateUsingEntityStaticID]:
    'The Entity Static ID can be used to update any existing Investor Entities or create new records.  Updating via Static ID also allows you to set the Entity CRM ID for new and existing records.'
};

export const importInvestorEntitiesQuickFilterOptions = [
  { label: 'All Rows', value: 'All Rows' },
  { label: 'Updates Only', value: 'Updates Only' },
  { label: 'Errors Only', value: 'Errors Only' }
];
